/**
 * Safe helper functions for checking user roles in documents
 */

/**
 * Checks if the user is the author of the content
 * Handles both string IDs and object IDs safely
 */
export const isAuthor = (kp_contributed_by, user) => {
  if (!user?._id) return false;
  if (!kp_contributed_by) return false;
  
  // Extract authorId safely - could be string ID or object with _id
  const authorId = typeof kp_contributed_by === 'string' 
    ? kp_contributed_by 
    : kp_contributed_by?._id;
  
  return authorId === user._id;
};

/**
 * Checks if the user is the current editor of the document
 * Handles both string IDs and object IDs safely
 * @param {string|object} currentEditor - The currentEditor field from the document
 * @param {object} user - The user object with _id property
 */
export const isCurrentEditor = (currentEditor, user) => {
  if (!user?._id) return false;
  if (!currentEditor) return false;
  
  // Extract editorId safely - could be string ID or object with _id
  const editorId = typeof currentEditor === 'string' 
    ? currentEditor 
    : currentEditor?._id;
  
  return editorId === user._id;
};

/**
 * Checks if the user is the current moderator of the document
 * Handles both string IDs and object IDs safely
 * @param {string|object} kp_moderator - The kp_moderator field from the document
 * @param {object} user - The user object with _id property
 */
export const isCurrentModerator = (kp_moderator, user) => {
  if (!user?._id) return false;
  if (!kp_moderator) return false;
  
  // Extract moderatorId safely - could be string ID or object with _id
  const moderatorId = typeof kp_moderator === 'string' 
    ? kp_moderator 
    : kp_moderator?._id;
  
  return moderatorId === user._id;
};